import React from 'react'
import IconBase from 'react-icon-base'

export default props => (
  <IconBase viewBox="0 0 24 24" {...props}>
    <rect
      x="2.16"
      y="11.171"
      transform="matrix(0.7072 0.7071 -0.7071 0.7072 11.9988 -4.9706)"
      width="19.68"
      height="1.659"
    />
    <rect
      x="11.171"
      y="2.159"
      transform="matrix(0.708 0.7062 -0.7062 0.708 11.9788 -4.971)"
      width="1.659"
      height="19.681"
    />
  </IconBase>
)



// WEBPACK FOOTER //
// ./~/@pickle/pickle-shared/src/components/Icons/CloseThin.jsx